import { ConfiguracionEstadoConductorDTO } from "../configuracionEstadoConductor.dto";
import { BaseResponseDTO } from "./base.response.dto";

export class GetConfiguracionEstadosConductorResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: Array<ConfiguracionEstadoConductorDTO>;

}
